import React, {
  createContext,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
  useContext,
  type JSX,
} from 'react';
import useLocalStorage from '@resources/js/hooks/useLocalStorage';

export type ThroughputBreakdownHiddenColumnsContext = {
  showAllColumns: boolean;
  setShowAllColumns: Dispatch<SetStateAction<boolean>>;
};

const defaultHiddenColumns = {
  showAllColumns: false,
  setShowAllColumns: () => undefined,
};

export const ThroughputBreakdownHiddenColumnsContext =
  createContext<ThroughputBreakdownHiddenColumnsContext>(defaultHiddenColumns);

export const ThroughputBreakdownHiddenColumnsProvider = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  return (
    <ThroughputBreakdownHiddenColumnsProviderInner>
      {children}
    </ThroughputBreakdownHiddenColumnsProviderInner>
  );
};

const ThroughputBreakdownHiddenColumnsProviderInner = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  const [showAllColumns, setShowAllColumns] = useLocalStorage(
    'BuildsThroughputSectionShowAllColumns',
    false,
  );

  return (
    <ThroughputBreakdownHiddenColumnsContext.Provider
      value={{ showAllColumns, setShowAllColumns }}
    >
      {children}
    </ThroughputBreakdownHiddenColumnsContext.Provider>
  );
};

const useThroughputBreakdownHiddenColumns: () => ThroughputBreakdownHiddenColumnsContext =
  () =>
    useContext(ThroughputBreakdownHiddenColumnsContext) ?? defaultHiddenColumns;

export default useThroughputBreakdownHiddenColumns;
